var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParpicsLogoTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 20.0413C18.6521 20.0523 21.1999 19.0093 23.0831 17.1417C24.9662 15.2741 26.0303 12.735 26.0413 10.0828C26.0523 7.43067 25.0093 4.88279 23.1417 2.99967C21.2741 1.11655 18.735 0.0524466 16.0828 0.0414536L16.0414 10.0414L15.9999 20.0413Z",
    fill: "#9FA9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 20.0413C11.3131 20.0467 12.6145 19.7935 13.8299 19.2959C15.0452 18.7984 16.1506 18.0664 17.0831 17.1417C18.0155 16.217 18.7566 15.1176 19.2642 13.9065C19.7718 12.6953 20.0358 11.396 20.0413 10.0828C20.0467 8.76961 19.7935 7.46819 19.2959 6.25286C18.7984 5.03753 18.0664 3.93209 17.1417 2.99967C16.2169 2.06724 15.1176 1.32608 13.9065 0.818513C12.6953 0.310941 11.396 0.0468965 10.0828 0.0414536L10.0414 10.0414L9.99992 20.0413Z",
    fill: "#4059DB",
    fillOpacity: 0.76
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParpicsLogoTemp);
export default __webpack_public_path__ + "static/media/parpics-logo-temp.441dcd22a8870a87523cacf338ba674c.svg";
export { ForwardRef as ReactComponent };